import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { helpers, http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* get() {
    try {
        const { userOrganisations } = yield select((state) => state);
        const { id } = userOrganisations.item;
        const url = `${config.api.paths.branchLocations}?organisation=${id}`;
        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On branch locations get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

export default function* () {
    yield all([takeLatest(actionTypes.BRANCH_LOCATIONS_GET_REQUEST, get)]);
}
